import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

// Theme configurations for different tenants
const themes = {
  default: {
    name: 'Ultimate Guard',
    logo: '🎲',
    colors: {
      primary: '#E6393D',
      secondary: '#C12B31',
      accent: '#F5895D',
      background: 'linear-gradient(135deg, #E6393D 0%, #C12B31 50%, #F5895D 100%)'
    }
  },
  sitehound: {
    name: 'Sitehound',
    logo: '/sitehound-logo.png',
    logoAlt: 'Sitehound Logo',
    mascot: '/charlie.png',
    mascotAlt: 'Charlie the Dog',
    colors: {
      primary: '#5A7D91',
      secondary: '#4A6B7F',
      accent: '#6B8BA3',
      background: 'linear-gradient(135deg, #4A6B7F 0%, #5A7D91 50%, #6B8BA3 100%)',
      light: '#E8F0F5'
    }
  }
};

export function ThemeProvider({ children, tenant = 'default' }) {
  const theme = themes[tenant] || themes.default;
  
  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
